export default {
  //删除所有cookies
  clearCookies() {
    let cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      let exp = new Date();
      exp.setTime(exp.getTime() - 1);
      let cookie = cookies[i];
      let eqPos = cookie.indexOf("=");
      let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      let domain = location.host.substr(location.host.indexOf('.'));
      document.cookie = name
        + "=;expires=" + exp.toGMTString();
    }
  },
  //删除cookies
  deleteCookie(name) {
    let exp = new Date();
    exp.setTime(exp.getTime() - 1);
    let cval = this.getCookie(name);
    if (cval != null)
      document.cookie = name + "=" + cval + ";expires="
        + exp.toGMTString();
  },
  //获取cookie
  getCookie(c_name) {
    if (document.cookie.length > 0) {
      let c_start = document.cookie.indexOf(c_name + "=");
      if (c_start != -1) {
        c_start = c_start + c_name.length + 1;
        let c_end = document.cookie.indexOf(";", c_start);
        if (c_end == -1) {
          c_end = document.cookie.length
        }
        return unescape(document.cookie.substring(c_start, c_end))
      }
    }
    return "";
  },
  //设置cookie 时间为秒
  setCookie(c_name, value, domain, seconds) {
    let exdate = new Date();
    let t = exdate.getTime() + parseInt(seconds)*1000;
    exdate.setTime(t);
    document.cookie = c_name + "=" + escape(value)
                  + ((domain == null) ? "" : ";path=" + domain)
                  + ((seconds == null) ? "" : ";expires=" + exdate.toUTCString())//注释原因：关闭浏览器清除cookies
  },
  //检测cookie是否存在
  checkCookie(name) {
    let username = getCookie(name);
    return (username != null && username != "");
  }

}



// WEBPACK FOOTER //
// ./src/utils/cookie.js